<style lang="scss" scoped>
.step {
  display: flex;

  margin-bottom: 0.58rem;

  flex-direction: column;
  align-items: center;
  .step-top-title {
    font-size: 0.36rem;
    line-height: 0.62rem;
    font-weight: 700;
    color: #f4daa6;
  }
  .step-time-box {
    width: 6.7rem;
    height: 0.98rem;

    background: no-repeat url('../images/bg_stage_operation_time.png');
    background-size: contain;
    .step-time {
      font-size: 0.24rem;
      line-height: 0.56rem;
      text-align: center;
      color: #62481e;
    }
  }
  .step-info {
    box-sizing: border-box;

    width: 6.98rem;
    margin-top: -1px;
    padding: 0.24rem 0.16rem;

    background-color: #b69256;
    border-radius: 0.2rem;
  }
}
</style>

<template>
  <li class="step">
    <p class="step-top-title">
      {{ stageInfo.stageRuleLogicTypeDesc }}
    </p>
    <div class="step-time-box">
      <p class="step-time">
        {{ `有效期: ${stageBeginTime} - ${stageEndTime}` }}
      </p>
    </div>
    <div class="step-info">
      <progress-info-box :stage-info="stageInfo"></progress-info-box>
      <package-info-box
        v-if="stageInfo.rewardPackList[0].rewardDtoList.length"
        :reward-info="stageInfo.rewardPackList[0]"
      ></package-info-box>
    </div>
  </li>
</template>

<script>
import ProgressInfoBox from './ProgressInfoBox'
import PackageInfoBox from './PackageInfoBox'
import { dateTimeFormatter } from '@/utils/utils'

export default {
  components: {
    ProgressInfoBox,
    PackageInfoBox
  },
  props: {
    stageInfo: {
      type: Object,
      required: true
    }
  },
  data() {
    return {}
  },
  computed: {
    stageBeginTime() {
      return dateTimeFormatter(
        this.stageInfo.stageBeginTime * 1000,
        'YYYY年MM月DD日'
      )
    },
    stageEndTime() {
      return dateTimeFormatter(
        this.stageInfo.stageEndTime * 1000,
        'YYYY年MM月DD日'
      )
    }
  }
}
</script>
